/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Wiki_Norecentlyviewed2Inputs */



/**

* @param {_Wiki_Norecentlyviewed2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _wiki_norecentlyviewed2 = /** @type {((inputs?: _Wiki_Norecentlyviewed2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Wiki_Norecentlyviewed2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Noch keine Einträge angesehen")
});
export { _wiki_norecentlyviewed2 as "_wiki_noRecentlyViewed" }